export default __webpack_public_path__ + "static/media/img_step_hami10.7575bc2b.png";